import { DDSTooltip, DDSTypography } from 'den-design-system'

import React from 'react'
import Tooltip from '../../New/Tooltip/Tooltip'
import pallete from '../../../global/newPallete'

interface APIOverviewCardData {
  id: any
  heading: string
  content: string | React.ReactNode
}

const APIOverviewCard: React.FC<APIOverviewCardData> = ({
  id,
  heading,
  content
}) => {
  return (
    <div
      id={id}
      className='relative flex flex-col rounded-md border  px-[20px] py-[16px]'
      style={{ borderColor: pallete.colors.stroke2 }}
    >
      <DDSTypography.Paragraph
        size='para'
        variant='regular'
        color={pallete.colors.textDark5}
      >
        {heading}
      </DDSTypography.Paragraph>
      <div className='pt-[8px] '>
        <Tooltip
          id={`info-${id}`}
          position='bottom'
          className={`override-tooltip-arrow max-w-[95%] break-all ${
            typeof content === 'string' && content.length > 20
              ? content
              : '!hidden'
          }`}
          label={
            <DDSTypography.Paragraph
              size='para'
              variant='regular'
              color={pallete.colors.primary2}
              className='max-w-[900px] break-words'
            >
              {content}
            </DDSTypography.Paragraph>
          }
        >
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.textDark3}
            className='truncate w-[96%]'
          >
            {content}
          </DDSTypography.Title>
        </Tooltip>
      </div>
    </div>
  )
}

export default APIOverviewCard
